import { siteName } from 'src/utils/oneCodeBase'

/**
 * The function `getConfigModules` imports a JavaScript file from a specific path based on each site Config
 * and returns its contents, or an empty object if there is an error.
 */
export const getConfigModules = filePath => {
  try {
    return require(`./${siteName}/${filePath}`)
  } catch (error) {
    console.log(siteName, filePath)
    console.error(`Error importing JavaScript file: ${error}`)
    return {}
  }
}
